import {
  Box,
  Divider,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import IconButton from "./IconButton";
import ByteChip from "../../icons/ByteChip";
import JobDataModal from "../modal/JobDataModal";

const JobResult = ({
  id,
  cost,
  duration,
  chunks,
  onClickFn,
  resultData,
}: {
  id: string;
  chunks: number;
  cost: number;
  duration: number;
  onClickFn: (id: string) => void;
  resultData: any;
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const byteChipWithText = (number: number) => {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          columnGap: "1px",
        }}
      >
        <ByteChip size="xs" />
        <Typography variant="body2">{number}</Typography>
      </Box>
    );
  };
  const formatSecondsToMin = (second: number) => {
    const min = Math.floor(second / 60);
    const sec = Math.floor(second % 60);
    return `${min}m ${sec}s`;
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleResultClick = (id: string) => {
    setOpenModal(true);
    onClickFn(id);
  };
  return (
    <Box
      sx={{
        borderLeft: "1px solid #B027CE",
        pl: 1,
        borderWidth: "2px",
      }}
    >
      <Typography color={"#470056"}>Results</Typography>

      <Table sx={{ width: "100%", mt: 1, border: "none" }}>
        <TableHead
          sx={{
            background: "#F9F9F9",
          }}
        >
          <TableRow>
            <TableCell
              sx={{ fontWeight: 600, fontSize: "12px", border: "none" }}
              className="table-header-left-cell"
              align="left"
            >
              Duration
            </TableCell>
            <TableCell
              sx={{ fontWeight: 600, fontSize: "12px", border: "none" }}
              align="left"
            >
              Cost
            </TableCell>
            <TableCell
              sx={{ fontWeight: 600, fontSize: "12px", border: "none" }}
              align="left"
            >
              No. Chunks
            </TableCell>
            <TableCell
              sx={{ fontWeight: 600, fontSize: "12px", border: "none" }}
              className="table-header-right-cell"
              align="left"
            >
              Outputs
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow
            sx={{ "&:first-child td, &:first-child th": { paddingTop: 3 } }}
          >
            <TableCell
              sx={{
                border: "none",
              }}
            >
              {formatSecondsToMin(duration)}
            </TableCell>
            <TableCell
              sx={{
                border: "none",
              }}
            >
              {byteChipWithText(cost)}
            </TableCell>
            <TableCell
              sx={{
                border: "none",
              }}
            >
              {chunks}
            </TableCell>
            <TableCell
              sx={{
                border: "none",
              }}
            >
              <IconButton
                label="Result"
                onClick={() => handleResultClick(id)}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <JobDataModal
        title="Job Results"
        openModal={openModal}
        handleClose={handleCloseModal}
      >
        {resultData}
      </JobDataModal>
    </Box>
  );
};

export default JobResult;
